/**
 * Publishing a session's results — may the signed-in person? (migration 1001)
 *
 * The act is `publishSessionResults` in stores/prioritization/sessionStore.ts,
 * whose cycle-bound lane is `publish_session_outcome`. That function applies
 * today's rule (the facilitator, the cycle owner or a workspace admin) and
 * then, since 1001, the cycle's "Items / selection" decision right when one is
 * set — the same right ratifying a Priority List asks (987), because publishing
 * ratifies the list in the same act.
 *
 * `fetchPublishRight` asks `can_publish_session_outcome` — the same answer —
 * so a page can leave Publish results out for a person who may not use it
 * (build contract §2.8) and show the database's own sentence instead.
 */

import { getTypedSupabaseClient } from './typedSupabaseClient';
import { actRightFromError, readActRight, type ActRight } from './actRight';

const PUBLISH_FALLBACK = 'You may not publish these results.';

export async function fetchPublishRight(sessionId: string): Promise<ActRight> {
  try {
    const { data, error } = await getTypedSupabaseClient().rpc('can_publish_session_outcome', {
      p_session_id: sessionId,
    });
    if (error) return actRightFromError(error, 'publish these results');
    return readActRight(data, PUBLISH_FALLBACK);
  } catch (err) {
    return actRightFromError({ message: err instanceof Error ? err.message : String(err) }, 'publish these results');
  }
}
